import { Component } from '@angular/core';

@Component({
  selector: 'app-delete-my-data',
  templateUrl: './delete-my-data.component.html',
})
export class DeleteMyDataComponent {

}
